import { IconSearch, Inline } from 'braid-design-system';
import queryString from 'query-string';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import Routes from 'src/config/routes';
import type {
  ClientListingForListingsTab,
  ListingProductForListingsTab,
} from 'src/types/graphql-derived';

import Action from './Action';
import { BoostButton } from './BoostButton';
import { EditAction } from './EditAction';
import { ExpireAction } from './ExpireAction';

interface PostedViewProps {
  listing: ClientListingForListingsTab;
  isLus: boolean;
  isFreemium: boolean;
  searchBoostProduct?: ListingProductForListingsTab;
  emailBoostProduct?: ListingProductForListingsTab;
  onEditClick: () => void;
  onExpireClick: () => void;
  onViewClick: () => void;
}

export const PostedView = ({
  listing,
  isLus,
  isFreemium,
  searchBoostProduct,
  emailBoostProduct,
  onEditClick,
  onExpireClick,
  onViewClick,
}: PostedViewProps) => {
  const boostProductsExist = searchBoostProduct && emailBoostProduct;
  const isAlreadyBooosted = listing.isPremium && listing.isListingEmailBoosted;

  return (
    <Inline space={{ mobile: 'medium', tablet: 'large' }}>
      <ExternalLink
        destination={queryString.stringifyUrl({
          url: Routes.VIEW_AD_URL + listing.id,
          query: {},
        })}
      >
        <Action Icon={IconSearch} action="View" onClick={onViewClick} />
      </ExternalLink>

      <EditAction listing={listing} onClick={onEditClick} />

      <ExpireAction onClick={onExpireClick} />

      {!isFreemium && boostProductsExist && !isAlreadyBooosted && (
        <BoostButton
          listing={listing}
          isLus={isLus}
          searchBoostProduct={searchBoostProduct}
          emailBoostProduct={emailBoostProduct}
        />
      )}
    </Inline>
  );
};
